
<template>
  <div class="bg-white shadow-md rounded sm:rounded-lg p-4 sm:p-6">
    <property-details :accountNumber="accountNumber" :property="property" :isRegistrationClosedOrFullyOpened="isRegistrationClosedOrFullyOpened"></property-details>

    <div class="mt-5 md:grid md:grid-cols-2 md:gap-6">
      <div class="md:col-span-2">
        <fieldset>
          <!-- Are you the owner of this property? -->
          <div class="block text-sm text-gray-600 mb-2">
            Are you the owner of this property?
          </div>

          <div class="space-y-4">
            <select v-model="data.isOwner" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" :class="{'border-red-500' : errors.isOwner}">
              <option value="" disabled>Please Select</option>
              <option value=1>Yes</option>
              <option value=0>No</option>
            </select>
          </div>

          <div class="text-red-600 text-sm px-1 py-1" v-if="errors.isOwner">
            <i class="fa fa-exclamation-triangle"></i> {{errors.isOwner}}
          </div>
        </fieldset>

        <fieldset>
          <!-- Is the information above correct? -->
          <div class="block text-sm text-gray-600 mb-2 mt-6">
            Is the information above correct?
          </div>

          <div class="space-y-4">
            <select v-model="data.isPropertyInformationCorrect" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" :class="{'border-red-500' : errors.isPropertyInformationCorrect}">
              <option value='' disabled>Please Select</option>
              <option value=1>Yes</option>
              <option value=0>No</option>
            </select>
          </div>

          <div class="text-red-600 text-sm px-1 py-1" v-if="errors.isPropertyInformationCorrect">
            <i class="fa fa-exclamation-triangle"></i> {{errors.isPropertyInformationCorrect}}
          </div>
        </fieldset>
      </div>
    </div>

    <div class="mt-4 sm:mt-6 text-center border-t pt-4 sm:pt-6">
      <a href="javascript:void(0)" @click="next()" class="inline-flex justify-center py-2 px-6 border border-transparent shadow-sm text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
        Continue
      </a>
    </div>
  </div>
</template>

<script>
import PropertyDetails from "./partial/PropertyDetails.vue";
export default {
  props: ["accountNumber", "property", "isRegistrationClosedOrFullyOpened"],
  components: {
    PropertyDetails,
  },
  data() {
    return {
      data: {
        isOwner: "",
        isYourPersonalName: "",
        isPropertyInformationCorrect: "",
      },
      errors: {},
    };
  },
  methods: {
    validateData() {
      this.errors = {};

      let error = false;

      if (!this.data.isOwner) {
        this.errors.isOwner = "Please tell if you are owner of the property";
        error = true;
      }

      if (!this.data.isPropertyInformationCorrect) {
        this.errors.isPropertyInformationCorrect =
          "Please tell if information above is correct";
        error = true;
      }

      return error;
    },
    next() {
      if (this.validateData()) return;

      var url = "/protest-requests/" + this.accountNumber;

      if (this.data.isOwner == 0) {
        window.location.href = url + "/not-qualify?reason=not_an_owner";
        return;
      }

      if (this.data.isPropertyInformationCorrect == 0) {
        window.location.href =
          url + "/not-qualify?reason=not_correct_information";
        return;
      }

      window.location.href = url + "/create/step2";
    },
  },
};
</script>
